import { render, staticRenderFns } from "./CustomScoringSampleTokens.vue?vue&type=template&id=07b965c7"
import script from "./CustomScoringSampleTokens.vue?vue&type=script&lang=js"
export * from "./CustomScoringSampleTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports